<template>
    <div class="activities-container">
        <div class="activity-list">
            <div v-if="localActivities?.length > 0" class="w-100 px-0">
                <div v-for="activity in localActivities" 
                    :key="activity.id" 
                    class="activity-item mb-3 col-12" 
                    v-if="activity.type.key != 'note'"
                >
                    <div class="checkbox px-0">
                        <div 
                            class="custom-checkbox" 
                            :class="{ 'checked': activity.completed_at }"
                            @click="!activity.completed_at && toggleActivity(activity)"
                            :style="activity.completed_at ? 'pointer-events: none' : ''"
                        >
                            <Component
                                v-if="activity.completed_at"
                                :is="'icon-check'"
                                :color="'#FFFFFF'"
                                :size="12"
                            />
                        </div>
                    </div>
                    <div class="activity-content px-0">
                        <div class="activity-type">
                            <Component
                                :is="icons[activity.type.key]?.component"
                                :color="'#8869FD'"
                                :size="14"
                            /> {{ activity.type.name}}
                        </div>
                        <div class="activity-description" :class="{ 'schedule_completed': activity.completed_at }">
                            {{ content(activity) }}
                        </div>
                        <div class="activity-meta">
                            <span class="date" :class="{ 'user_completed': activity.completed_at }">{{ formatDate(activity.scheduled_at) }}</span>
                            <span class="user text-truncate">{{ activity.user.first_name }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="no-activities" :class="{ 'deal-modal': isDealModal }">
                <img src="/build/icons/sad-cloud-no-activities.svg"/>
                <p class="no-activities-count">{{ __('0 Atividades') }}</p>
                <p class="no-activities-message">{{ __('Não existem atividades programadas.') }}</p>
            </div>
        </div>
        <FinishActivityModal 
            ref="finishActivityModal"
            :activityId="selectedActivity?.id" 
            @confirmFinish="handleFinishActivity" 
        />
    </div>
</template>

<script>
import FinishActivityModal from '../activity/FinishActivityModal.vue';

export default {
    name: 'ActivityList',
    props: {
        hash: {
            type: String,
            required: false,
        },
        activities: {
            type: [Array, null],
            default: null
        },
        isDealModal: {
            type: Boolean,
            default: false
        }
    },
    components: {
        FinishActivityModal
    },
    data() {
        return {
            localActivities: this.activities,
            selectedActivity: null,
            icons: {
                note: { component: 'icon-pencil', size: 15, color: '#242424', hidden: false },
                call: { component: 'icon-phone', size: 16, color: '#242424', hidden: false },
                email: { component: 'icon-envelope', size: 17, color: '#242424', hidden: false },
                visit: { component: 'icon-briefcase', size: 15, color: '#242424', hidden: false },
                meeting: { component: 'icon-coffee', size: 17, color: '#242424', hidden: false },
                proposal: { component: 'icon-fileText', size: 17, color: '#242424', hidden: false },
                whatsapp: { component: 'icon-fileText', size: 17, color: '#242424', hidden: true },
            }
        }
    },
    mounted() {
        if (this.activities) {
            this.localActivities = this.activities;
        } else {
            this.fetchActivities();
        }
    },
    created() {
        Bus.$on('activityCreated', () => {
            this.fetchActivities();
        });
        Bus.$on('activity-updated', () => {
            this.fetchActivities();
        });
        Bus.$on('activity-deleted', () => {
            this.fetchActivities();
        });
        Bus.$on(`lead.${this.hash}.activity.complete`, (data) => {
            this.fetchActivities();
        });
    },
    beforeDestroy() {
        Bus.$off('activityCreated');
        Bus.$off('activity-updated');
        Bus.$off('activity-deleted');
        Bus.$off(`lead.${this.hash}.activity.complete`);
    },
    watch: {
        activities: {
            handler () {
                this.localActivities = this.activities;
            },
        },
    },
    methods: {
        fetchActivities() {
            this.$http
            .get(`/lead/${this.hash}/activity?today=true&per_page=10`)
            .then(({ data }) => {
                this.localActivities = data?.data || [];
            })
            .catch((error) => {
                console.error('Error:', error.responseJSON)
            })
        },
        stripHtml(html) {
            const tmp = document.createElement('div');
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || '';
        },
        formatDate(date) {
            if (!date) return '';
            const d = new Date(date);
            const day = d.getDate().toString().padStart(2, '0');
            const month = (d.getMonth() + 1).toString().padStart(2, '0');
            const year = d.getFullYear();
            const hours = d.getHours().toString().padStart(2, '0');
            const minutes = d.getMinutes().toString().padStart(2, '0');
            
            return `${day}/${month}/${year} às ${hours}:${minutes}`;
        },
        toggleActivity(activity) {
            this.selectedActivity = null;
            this.$nextTick(() => {
                this.selectedActivity = activity;
                const modal = this.$refs.finishActivityModal;
                if (modal) {
                    modal.handleOpen(activity);
                } else {
                    Bus.$emit('openFinishActivityModal', activity);
                }
            });
        },
        content(activity) {
            const content = activity.content || activity.summary;

            return this.stripHtml(content).substring(0, 130) + (content?.length > 130 ? '...' : '');
        },
        handleFinishActivity({ activity, completed_status, closeModal }) {
            const hash = this.hash ? this.hash : activity.lead_hashid;

            this.$http
            .put(`/lead/${hash}/activity/${activity.id}`, {
                complete: true,
                completed_status: completed_status
            })
            .then(({ data }) => {
                if (this.hash) {
                    this.fetchActivities();
                    Bus.$emit(`lead.${this.hash}.activity.complete`, data);
                }

                this.$emit('activityCompleted', activity);
                closeModal();
            })
            .catch(error => {
                console.error('Error updating activity:', error);
            });
        },
    }
}
</script>

<style scoped>
.activity-item {
    display: flex;
    align-items: flex-start;
    padding: 0 16px;
    gap: 16px;
}

.activity-content {
    flex: 1;
}

.activity-type {
    color: #8869FD;
    font-family: Montserrat;
    font-size: 10px;
    font-weight: 600;
    margin-bottom: 6px;
}

.activity-description {
    color: #242424;
    margin-bottom: 4px;
    word-break: break-word;
    overflow-wrap: break-word;
}

.activity-meta {
    color: #7E5DF4;
    font-size: 10px;
    font-weight: 600;
    display: flex;
    gap: 5px;
    white-space: nowrap;
    align-items: center;
}

.activity-meta .user {
    color: #242424;
    max-width: 50px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
}

.checkbox {
    display: flex;
    align-items: center;
}

.custom-checkbox {
    width: 20px;
    height: 20px;
    border-radius: 100px;
    background: #FFF;
    box-shadow: 0px 2px 5px 0px rgba(103, 110, 118, 0.08),
                0px 0px 0px 1px rgba(103, 110, 118, 0.16),
                0px 1px 1px 0px rgba(0, 0, 0, 0.12);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.custom-checkbox.checked {
    background-color: #8869FD;
    box-shadow: none;
    padding-top: 3px;
}

.activities-container {
    min-height: 500px;
    display: flex;
    flex-direction: column;
}

.activity-list {
    flex: 1;
    display: flex;
}

.no-activities {
    text-align: center;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
}

.no-activities-count {
    color: #939090;
    font-weight: 700;
    font-size: 12px;
    text-align: center;
    font-family: Montserrat;
}

.no-activities-message {
    color:  #71767D;
    text-align: center;
    font-family: Montserrat;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
}
.schedule_completed {
    text-decoration-line: line-through;
    color: #AAAAAB;
}
.user_completed {
    color: #64748B;
}
</style>